import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose, IconMenu } from '@travel-frontend/icons';
import { useMemo } from 'react';
import { SeoHeader } from '../../components/Header/components/SeoHeader.js';
import { Control as HeaderControl } from '../../components/HeaderNew/components/Control.js';
import { ControlApp } from '../../components/HeaderNew/components/ControlApp.js';
import { Container } from '../../components/MobileMenu/components/Container.js';
import { Content } from '../../components/MobileMenu/components/Content.js';
import { MenuItem } from '../../components/MobileMenu/components/MenuItem/index.js';
import { HoverWrapper } from '../../components/MobileMenu/components/MenuItem/components/HoverWrapper.js';
import { SubItem } from '../../components/MobileMenu/components/SubItem/index.js';
import { SubMenuArea } from '../../components/MobileMenu/components/SubMenuArea.js';
import { useBooleanToggle } from '../../hooks/index.js';
import { Drawer, Stack } from '../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../utils/qaId.js';
import { SPACING_MEDIUM, SPACING_XLARGE } from '../../utils/spacingLegacy.js';
function safeFlatItems(arrayWithItems) {
  return arrayWithItems?.flatMap(({
    items
  }) => items) ?? [];
}
export const MobileMenu = ({
  config,
  additionalItems,
  ...restProps
}) => {
  const [isOpen, handleToggle] = useBooleanToggle();
  const mappedConfig = useMemo(() => config.map(({
    items,
    ...rest
  }) => ({
    ...rest,
    items: safeFlatItems(items)
  })), [config]);
  return _jsxs(Container, {
    ...restProps,
    children: [_jsx(HeaderControl, {
      children: _jsx(IconMenu, {
        onClick: handleToggle
      })
    }), _jsx(SeoHeader, {
      children: mappedConfig.map(({
        id,
        caption,
        items,
        link
      }) => _jsx(HoverWrapper, {
        children: _jsx(MenuItem, {
          onClose: handleToggle,
          link: link,
          label: caption,
          "data-cy": qaId(HEADER_QA_ID, 'menuItem', caption),
          "data-testid": qaId(HEADER_QA_ID, 'menuItem', caption)
        })
      }, id))
    }), _jsx(Drawer, {
      anchor: "right",
      open: isOpen,
      onClose: handleToggle,
      children: _jsxs(Stack, {
        spacing: SPACING_XLARGE,
        children: [_jsx(Stack, {
          spacing: SPACING_MEDIUM,
          children: _jsxs(Content, {
            children: [_jsx(ControlApp, {
              onClick: handleToggle,
              children: _jsx(IconClose, {
                fontScale: "large"
              })
            }), mappedConfig.map(({
              id,
              caption,
              items,
              link
            }) => _jsx(HoverWrapper, {
              children: _jsx(MenuItem, {
                onClose: handleToggle,
                link: link,
                label: caption,
                "data-cy": qaId(HEADER_QA_ID, 'menuItem', caption),
                "data-testid": qaId(HEADER_QA_ID, 'menuItem', caption),
                children: items.length > 0 && _jsx(SubMenuArea, {
                  "data-cy": qaId(HEADER_QA_ID, 'menuLinks', caption),
                  "data-testid": qaId(HEADER_QA_ID, 'menuLinks', caption),
                  children: items.map(({
                    id,
                    caption,
                    path,
                    masked,
                    target
                  }) => _jsx(SubItem, {
                    href: path,
                    masked: masked,
                    target: target,
                    children: caption
                  }, id))
                })
              })
            }, id))]
          })
        }), additionalItems]
      })
    })]
  });
};